import React, { useEffect, useState } from "react"
import { Formik, Form } from "formik";
import Select from "react-select"
import styled from "styled-components"

const Champ = styled.div`
margin:10px auto;
padding: 0;
`

const AssociationSelect = styled(Select)`
margin: 10px;
max-width: 500px;
display: block;
`

const construitOption = (typeElement, element) => {
  const retour = {}
  switch (typeElement) {
    case 'document':
      retour.value = element.id
      retour.label = `${element.titre} - ${element.code_barre}`
      break
    case 'inscription':
      retour.value = element.id
      retour.label = `${element.titre} - ${element.identifiant}`
      break
    case 'auteur':
      retour.value = element.id
      retour.label = `${element.nom} - ${element.prenom}`
      break
    case 'donnee':
      retour.value = element.id
      retour.label = `${element.nom_fichier}`
      break
    case 'collection':
    retour.value = element.id
    retour.label = `${element.libelle}`
    break
    default:
      break
  }
  return retour
}

const valeurs = (typeElement, elem) => {
  if (! elem){
    return null
  }
  return (construitOption(typeElement, elem))
}


/**
 * Association d'un theatre avec des phototheatres
 * typeElement theatre
 * typeElementAAssocier phototheatre
 * liste toutes les phototheatres
**/
const ElementFormAssociationUnique = (params) => {

  const {initialValues
    , typeElementAAssocier
    , liste
    , onSubmit} = params

  const [selectedOption, setSelectedOption] = useState();

  useEffect(() => {
      const alias = `${typeElementAAssocier}`
      setSelectedOption(valeurs(typeElementAAssocier, initialValues[alias]))
  }, [typeElementAAssocier, initialValues])


  const handleSelect = (data) => {
    const tempo = [data]
    setSelectedOption(tempo);
  }

//creation de l'element select multiple
const FormSelect = ({ name, options }) => {

  return (
      <AssociationSelect
        name={name}
        defaultValue={selectedOption}
        onChange={handleSelect}
        options={options}
        isSearchable={true}
        isClearable={true}
      />
  );
};

  const FormulaireJSX = () => {
      return(
      <Form>
        <Champ>
          <FormSelect
            name={typeElementAAssocier}
            options={liste.map(element => construitOption(typeElementAAssocier, element))}
          />
          <button type="submit" d={`association_${typeElementAAssocier}`} onSubmit={onSubmit}>Associer</button>
        </Champ>
      </Form>)
  }
  return (
        <Formik
          initialValues={selectedOption}
          onSubmit={onSubmit}
          enableReinitialize={true}>
          <FormulaireJSX />
        </Formik>
  )
}
export default ElementFormAssociationUnique